<template>

    <div class="wrapper">
        <admin-partial-navbar></admin-partial-navbar>
        <admin-partial-sidebar></admin-partial-sidebar>
        <div class="content-wrapper">
            <router-view></router-view>
        </div>
        <admin-partial-footer></admin-partial-footer>
    </div>
</template>

<script>
export default {
    name: "AdminApp.vue",
    data() {
        return {
            isLoggedIn: false,
            user: false,
        }
    },
    async mounted() {
        await this.axios.get(`/api/profile`)
            .then(response=>{
                if(response.data.role_id !== 1 && response.data.role_id !== 3){
                    location.href='/';
                }

                this.user = response.data;
                if(response.data.role_id === 3){
                    this.$router.push({name:'invoicesList'})
                }
            })
            .catch(error=>{
                location.href='/login';
            });
    },
    methods: {
        async logout() {
            await this.axios.get('/sanctum/csrf-cookie').then(response => {
                this.axios.post('/api/logout')
                    .then(response => {
                        if (response.data.success) {
                            sessionStorage.clear();
                            this.isLoggedIn = false;
                            this.$cookies.remove('jwt');
                            location.href='/';
                        } else {
                            console.log(response)
                        }
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            })
        }
    }
}
</script>

<style scoped>

</style>
